import { omit, pick } from 'shared/utils/objectUtils'

export const isRequired = object =>
  Object.fromEntries(
    Object.entries(object).map(([key, val]) => [key, val.isRequired])
  )

export const pickRequired = (obj, keys) => isRequired(pick(obj, keys))
export const omitRequired = (obj, keys) => isRequired(omit(obj, keys))
